import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { FornecedorSchema } from '../types/Fornecedor';

export type FornecedorGetParams = DefaultApiParams &
    Partial<{
        pesquisar: string;
        nome: string;
        documento: string;
        marcadores: string;
    }>;

type FornecedorGetProps = {
    idpk?: number;
    params?: FornecedorGetParams;
};

const schema = registrosSchema(FornecedorSchema);

function apiFornecedorGet({ idpk, params }: FornecedorGetProps) {
    return fetchApi({
        endpoint: 'Fornecedor/Fornecedor',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const FORNECEDOR_GET_KEY = 'apiFornecedorGet';

export function fornecedorGetQueryOptions({ idpk, params }: FornecedorGetProps) {
    return queryOptions({
        queryFn: () => apiFornecedorGet({ idpk, params }),
        queryKey: [FORNECEDOR_GET_KEY, { idpk, params }],
    });
}
